module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp6-805c5002d853a4d1822ba600936fdfaa.jpg";